// extracted by mini-css-extract-plugin
export default {"headerHome":"HomeSW_headerHome__1Efd9","SFWBList":"HomeSW_SFWBList__5icHD","SFWBList2":"HomeSW_SFWBList2__O618w","SFWBQuery":"HomeSW_SFWBQuery__jBI1M"};